import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/home';

const slideImages = [
  'https://readdy.ai/api/search-image?query=Dramatic%20soccer%20stadium%20at%20night%20floodlit%20pitch%20intense%20atmosphere%20crowded%20stands%20professional%20sports%20photography%20cinematic%20lighting%20deep%20contrast%20warm%20golden%20tones%20epic%20scale%20champions%20league%20vibe&width=1920&height=900&seq=hero-football&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Intense%20basketball%20arena%20with%20dramatic%20spotlight%20on%20court%20packed%20crowd%20NBA%20playoffs%20atmosphere%20cinematic%20sports%20photography%20warm%20golden%20tones%20dynamic%20action%20professional%20arena%20epic%20wide%20shot&width=1920&height=900&seq=hero-basketball&orientation=landscape',
];

export default function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const goToSlide = useCallback((index: number) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide(index);
    setTimeout(() => setIsTransitioning(false), 600);
  }, [isTransitioning]);

  useEffect(() => {
    const timer = setInterval(() => {
      goToSlide((currentSlide + 1) % heroSlides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [currentSlide, goToSlide]);

  const slide = heroSlides[currentSlide];

  return (
    <section className="relative w-full h-[580px] md:h-[680px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={slideImages[currentSlide]}
          alt={slide.title}
          className="w-full h-full object-cover transition-opacity duration-700"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65"></div>
      </div>

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div
              key={currentSlide}
              className="max-w-2xl animate-[fadeInUp_0.6s_ease-out]"
            >
              <span className="inline-block px-3 py-1 rounded-full bg-accent-500/90 text-white text-xs font-semibold mb-4 tracking-wide uppercase">
                {slide.subtitle}
              </span>
              <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-4 leading-tight">
                {slide.title}
              </h1>
              <p className="text-white/80 text-base md:text-lg mb-8 max-w-lg leading-relaxed">
                {slide.description}
              </p>
              <div className="flex items-center gap-4 flex-wrap">
                <Link
                  to={slide.ctaLink}
                  className="px-6 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  {slide.cta}
                </Link>
                <Link
                  to={slide.secondaryCtaLink}
                  className="px-6 py-3 rounded-full border border-white/40 text-white font-semibold text-sm hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  {slide.secondaryCta}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
              index === currentSlide
                ? 'bg-primary-500 w-8'
                : 'bg-white/40 hover:bg-white/70'
            }`}
            aria-label={`切换到第${index + 1}张`}
          />
        ))}
      </div>

      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
}